export const SKUModelMapper=(obj)=>{
  obj.Status = '';
  return obj;
};